import { userTemplateColumns } from '../../../lib/constants';
import { isEmail } from '../../../lib/utils';
import { Role } from '../../../modules/users/roles/types';
import { Account } from '../../../modules/users/types';
import { CSVUser } from './types';

const removeDoubleQuotesFromHeaders = (headers: string[]): string[] => {
  const newHeaderColumns = headers.map((header) => header.replaceAll('"', ''));
  return newHeaderColumns;
};

const validateHeaders = (headers: string[]) => {
  let matches = 0;
  userTemplateColumns.forEach((header) => {
    if (headers.includes(header)) {
      matches += 1;
    }
  });
  return matches === userTemplateColumns.length;
};

const validateCSVUsers = (
  users: CSVUser[],
  accounts: Account[],
  roles: Role[],
) => {
  const userMap = new Map<string, CSVUser>();
  const accountEmailsSet = new Set([...accounts.map((account) => account.email)]);
  const defaultRole = roles.find((role) => role.isDefault)?.roleName || '';
  users.forEach((user) => {
    const email = user['Email address (Mandatory)'];
    if (
      email && isEmail(email) && !userMap.has(email)
      && !accountEmailsSet.has(email)
    ) {
      user.Role = (
        user.Role
        && roles
        && roles.find((role) => role.roleName === user.Role)
      ) ? user.Role : defaultRole;
      userMap.set(email, user);
    }
  });

  return [...userMap.values()];
};

export const parseUsersFromCSV = (
  accounts: Account[],
  roles: Role[],
  content: string,
  separator = ',',
): CSVUser[] => {
  // to split content into rows
  // and remove line terminators from rows
  const rows = content.split('\n').map((row) => row.trimEnd());
  const headers = removeDoubleQuotesFromHeaders(rows[0].split(separator));

  if (!validateHeaders(headers)) {
    throw new Error('Invalid Headers in CSV');
  }

  const newArray: CSVUser[] = [];
  rows.forEach((row, rowIndex) => {
    if (rowIndex === 0) {
      return;
    }

    const values = row.split(separator);
    const eachObject = { selected: true };
    headers.forEach((header, index) => {
      eachObject[header] = values[index];
    });
    newArray.push(eachObject as CSVUser);
  });

  const users = validateCSVUsers(newArray, accounts, roles);

  if (users.length === 0) {
    throw new Error('No valid users in CSV');
  }

  return users;
};
